import React from "react"
import UpdateImportWizard from "./UpdateImportWizard"

const ImportUpdater = () => {
  return (
    <div className="h-full">
      <UpdateImportWizard
        onClose={() => {
          // Navigate back or close
          window.history.back()
        }}
      />
    </div>
  )
}

export default ImportUpdater
